import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ClientContext } from "../state/ClientContext";

export const useSyncSelectedClient = () => {
  const { clientId, caregiverId } = useParams();
  const { changeSelectedClient, changeSelectedCaregiver } =
    useContext(ClientContext);
  useEffect(() => {
    changeSelectedClient(clientId);
    changeSelectedCaregiver(caregiverId);
  }, [clientId, caregiverId, changeSelectedClient, changeSelectedCaregiver]);
};
